<scitis-breadcrumb [breadcrumbRoutes]="routes"></scitis-breadcrumb>
<scitis-app-global-page-header>
  <div header-title>
    <scitis-page-header-logo-and-name
      [machineCategory]="pageGlobalParameters.machineCategory"
      [machineId]="pageGlobalParameters.machineId"
      [pageName]="pageGlobalParameters.pageName"
      [pageType]="pageGlobalParameters.pageType">

    </scitis-page-header-logo-and-name>
  </div>

  <ng-template #filterElement>
    <scitis-machine-page-header
      [pageType]="pageGlobalParameters.pageType"
      [pageName]="pageGlobalParameters.pageName"
      [machineCategory]="pageGlobalParameters.machineCategory"
      [machineId]="pageGlobalParameters.machineId"
      [organizationId]="pageGlobalParameters.organizationId"
      [pageId]="pageGlobalParameters.pageId">

    </scitis-machine-page-header>
  </ng-template>


</scitis-app-global-page-header>

<div class="page-content">

  @if (isLookerPage) {
    <scitis-looker-page>
    </scitis-looker-page>
  }

  @if (isWebGLPage) {
    <scitis-webgl-page>
    </scitis-webgl-page>
  }

</div>
